/**
 * Textes de l’onglet Webhooks (établissement). Les clés suffixées `.edu` donnent la variante
 * « éducation » (élèves, cours, classes…) ; sans suffixe : variante entreprise / par défaut.
 * Les autres langues retombent sur l’anglais.
 */
const fr: Record<string, string> = {
  'institution.webhooks.title': 'Webhooks',
  'institution.webhooks.subtitle': 'Recevez en temps réel les événements de vos formations dans vos outils (SIRH, LMS, CRM, automatisations…).',
  'institution.webhooks.subtitle.edu': 'Recevez en temps réel les événements de vos cours et de vos classes dans vos outils (ENT, vie scolaire, automatisations…).',
  'institution.webhooks.segmentBadge': 'Établissement entreprise',
  'institution.webhooks.segmentBadge.edu': 'Établissement éducation',
  'institution.webhooks.new': 'Nouveau webhook',
  'institution.webhooks.emptyTitle': 'Aucun webhook configuré',
  'institution.webhooks.emptyBody': 'Un webhook envoie une requête HTTPS signée à votre outil dès qu’un apprenant s’inscrit, termine une formation, obtient un score…',
  'institution.webhooks.emptyBody.edu': 'Un webhook envoie une requête HTTPS signée à votre outil dès qu’un élève est inscrit, termine un cours, reçoit une note…',
  'institution.webhooks.emptyCta': 'Créer votre premier webhook',
  'institution.webhooks.active': 'Actif',
  'institution.webhooks.inactive': 'Inactif',
  'institution.webhooks.createdOn': 'Créé le {{date}}',
  'institution.webhooks.lastSent': 'Dernier envoi : {{date}}',
  'institution.webhooks.logCount_one': '{{count}} envoi journalisé',
  'institution.webhooks.logCount_other': '{{count}} envois journalisés',
  'institution.webhooks.action.test': 'Envoyer un test',
  'institution.webhooks.action.logs': 'Voir le journal',
  'institution.webhooks.action.enable': 'Activer',
  'institution.webhooks.action.disable': 'Désactiver',
  'institution.webhooks.action.edit': 'Modifier',
  'institution.webhooks.action.delete': 'Supprimer',
  'institution.webhooks.action.copySecret': 'Copier le secret',
  'institution.webhooks.clickForFilters': 'Cliquer pour voir les filtres',
  'institution.webhooks.drawerCreateTitle': 'Nouveau webhook',
  'institution.webhooks.drawerEditTitle': 'Modifier le webhook',
  'institution.webhooks.drawerHint': 'Définissez l’URL HTTPS, les événements déclenchés et, si besoin, le secret de signature.',
  'institution.webhooks.drawerSubmitCreate': 'Créer le webhook',
  'institution.webhooks.drawerSubmitUpdate': 'Mettre à jour',
  'institution.webhooks.field.name': 'Nom',
  'institution.webhooks.field.namePlaceholder': 'Ex. : Synchronisation SIRH',
  'institution.webhooks.field.namePlaceholder.edu': 'Ex. : Synchronisation ENT',
  'institution.webhooks.field.url': 'URL cible (HTTPS)',
  'institution.webhooks.field.urlHint': 'Adresse publique en https://. Les adresses internes (localhost, réseau privé) sont refusées.',
  'institution.webhooks.field.events': 'Événements',
  'institution.webhooks.field.eventsHint': 'Choisissez au moins un événement.',
  'institution.webhooks.field.secret': 'Secret de signature',
  'institution.webhooks.field.secretPlaceholder': 'Laissez vide pour en générer un automatiquement',
  'institution.webhooks.field.secretHint': 'Sert à signer chaque envoi (en-tête X-Webhook-Signature). 16 caractères minimum.',
  'institution.webhooks.filters': 'Filtres',
  'institution.webhooks.filtersEmptyMeansAll': 'vide = tous',
  'institution.webhooks.filtersConfigured': 'Filtres configurés',
  'institution.webhooks.filtersConfigure': 'Configurer les filtres',
  'institution.webhooks.filterFlows': 'Formations',
  'institution.webhooks.filterFlows.edu': 'Cours',
  'institution.webhooks.filterBlocks': 'Blocs',
  'institution.webhooks.filterBlocks.edu': 'Activités',
  'institution.webhooks.filterPodcasts': 'Podcasts',
  'institution.webhooks.filterChangeTypes': 'Type de modification',
  'institution.webhooks.filterNoFlows': 'Aucune formation dans l’établissement.',
  'institution.webhooks.filterNoFlows.edu': 'Aucun cours dans l’établissement.',
  'institution.webhooks.filterNoPodcasts': 'Aucun podcast dans l’établissement.',
  'institution.webhooks.activeFilters': 'Filtres actifs',
  'institution.webhooks.changeType.content': 'Contenu',
  'institution.webhooks.changeType.settings': 'Paramètres',
  'institution.webhooks.changeType.status': 'Statut',
  'institution.webhooks.toast.created': 'Webhook créé',
  'institution.webhooks.toast.updated': 'Webhook mis à jour',
  'institution.webhooks.toast.deleted': 'Webhook supprimé',
  'institution.webhooks.toast.enabled': 'Webhook activé',
  'institution.webhooks.toast.disabled': 'Webhook désactivé',
  'institution.webhooks.toast.testing': 'Envoi du test…',
  'institution.webhooks.toast.testOk': 'Test réussi ({{status}}, {{duration}} ms)',
  'institution.webhooks.toast.copied': 'Copié',
  'institution.webhooks.toast.secretCopied': 'Secret copié',
  'institution.webhooks.error.save': 'Erreur lors de l’enregistrement',
  'institution.webhooks.error.delete': 'Erreur lors de la suppression',
  'institution.webhooks.error.toggle': 'Impossible de changer l’état du webhook',
  'institution.webhooks.error.test': 'Le test n’a pas pu être envoyé',
  'institution.webhooks.error.logs': 'Impossible de charger le journal',
  'institution.webhooks.logsTitle': 'Journal — {{name}}',
  'institution.webhooks.logsCount_one': '{{count}} envoi',
  'institution.webhooks.logsCount_other': '{{count}} envois',
  'institution.webhooks.logsEmpty': 'Aucun envoi pour ce webhook.',
  'institution.webhooks.logStatus.success': 'Réussi',
  'institution.webhooks.logStatus.retrying': 'Nouvel essai prévu',
  'institution.webhooks.logStatus.failed': 'Échec',
  'institution.webhooks.logAttempt': 'tentative {{n}}',
  'institution.webhooks.logTest': 'test',
  'institution.webhooks.payloadSent': 'Données envoyées',
  'institution.webhooks.response': 'Réponse',
  'institution.webhooks.error': 'Erreur',
  'institution.webhooks.copy': 'Copier',
  'institution.webhooks.copyPayload': 'Copier les données',
  'institution.webhooks.close': 'Fermer',
  'institution.webhooks.testOk': 'Test réussi',
  'institution.webhooks.testFailed': 'Échec du test',
  'institution.webhooks.testEvent': 'Événement',
  'institution.webhooks.testStatus': 'Statut HTTP',
  'institution.webhooks.testDuration': 'Durée',
  'institution.webhooks.testAgainWith': 'Renvoyer un test avec',
  'institution.webhooks.testAgain': 'Renvoyer',
  'institution.webhooks.deleteTitle': 'Supprimer ce webhook ?',
  'institution.webhooks.deleteBody': 'Les envois s’arrêtent immédiatement et le journal est supprimé.',
  'institution.webhooks.cancel': 'Annuler',
  'institution.webhooks.help.title': 'Recevoir et vérifier les envois',
  'institution.webhooks.help.body': 'Chaque événement est envoyé en POST JSON : { id, event, createdAt, institution: { id, type }, data }. Répondez par un code 2xx en moins de 10 secondes ; sinon l’envoi est retenté après 1 minute puis 10 minutes. L’en-tête X-Webhook-Id reste identique entre les tentatives : utilisez-le pour ignorer les doublons.',
  'institution.webhooks.help.signature': 'Vérifiez la signature : HMAC-SHA256 du texte « X-Webhook-Timestamp.corps brut » avec votre secret, comparé à X-Webhook-Signature (préfixe sha256=).',
  'institution.webhooks.help.show': 'Afficher l’exemple de vérification',
  'institution.webhooks.help.hide': 'Masquer l’exemple',
  'institution.webhooks.help.vocabulary': 'Les identifiants techniques restent les mêmes pour tous les établissements : learner = apprenant, flow = formation, block = bloc, class = groupe.',
  'institution.webhooks.help.vocabulary.edu': 'Les identifiants techniques sont communs à tous les établissements : learner = élève, flow = cours, block = activité, class = classe, score = note.',
};

const en: Record<string, string> = {
  'institution.webhooks.title': 'Webhooks',
  'institution.webhooks.subtitle': 'Receive your training events in real time in your tools (HRIS, LMS, CRM, automations…).',
  'institution.webhooks.subtitle.edu': 'Receive your course and class events in real time in your tools (school platform, student records, automations…).',
  'institution.webhooks.segmentBadge': 'Enterprise institution',
  'institution.webhooks.segmentBadge.edu': 'Education institution',
  'institution.webhooks.new': 'New webhook',
  'institution.webhooks.emptyTitle': 'No webhook configured',
  'institution.webhooks.emptyBody': 'A webhook sends a signed HTTPS request to your tool as soon as a learner enrols, completes a training, gets a score…',
  'institution.webhooks.emptyBody.edu': 'A webhook sends a signed HTTPS request to your tool as soon as a student is enrolled, completes a course, gets a grade…',
  'institution.webhooks.emptyCta': 'Create your first webhook',
  'institution.webhooks.active': 'Active',
  'institution.webhooks.inactive': 'Inactive',
  'institution.webhooks.createdOn': 'Created on {{date}}',
  'institution.webhooks.lastSent': 'Last sent: {{date}}',
  'institution.webhooks.logCount_one': '{{count}} logged delivery',
  'institution.webhooks.logCount_other': '{{count}} logged deliveries',
  'institution.webhooks.action.test': 'Send a test',
  'institution.webhooks.action.logs': 'View log',
  'institution.webhooks.action.enable': 'Enable',
  'institution.webhooks.action.disable': 'Disable',
  'institution.webhooks.action.edit': 'Edit',
  'institution.webhooks.action.delete': 'Delete',
  'institution.webhooks.action.copySecret': 'Copy secret',
  'institution.webhooks.clickForFilters': 'Click to see the filters',
  'institution.webhooks.drawerCreateTitle': 'New webhook',
  'institution.webhooks.drawerEditTitle': 'Edit webhook',
  'institution.webhooks.drawerHint': 'Set the HTTPS URL, the events to send and, if needed, the signing secret.',
  'institution.webhooks.drawerSubmitCreate': 'Create webhook',
  'institution.webhooks.drawerSubmitUpdate': 'Update',
  'institution.webhooks.field.name': 'Name',
  'institution.webhooks.field.namePlaceholder': 'e.g. HRIS sync',
  'institution.webhooks.field.namePlaceholder.edu': 'e.g. School platform sync',
  'institution.webhooks.field.url': 'Target URL (HTTPS)',
  'institution.webhooks.field.urlHint': 'Public https:// address. Internal addresses (localhost, private network) are refused.',
  'institution.webhooks.field.events': 'Events',
  'institution.webhooks.field.eventsHint': 'Choose at least one event.',
  'institution.webhooks.field.secret': 'Signing secret',
  'institution.webhooks.field.secretPlaceholder': 'Leave empty to generate one',
  'institution.webhooks.field.secretHint': 'Used to sign every delivery (X-Webhook-Signature header). At least 16 characters.',
  'institution.webhooks.filters': 'Filters',
  'institution.webhooks.filtersEmptyMeansAll': 'empty = all',
  'institution.webhooks.filtersConfigured': 'Filters set',
  'institution.webhooks.filtersConfigure': 'Set filters',
  'institution.webhooks.filterFlows': 'Trainings',
  'institution.webhooks.filterFlows.edu': 'Courses',
  'institution.webhooks.filterBlocks': 'Blocks',
  'institution.webhooks.filterBlocks.edu': 'Activities',
  'institution.webhooks.filterPodcasts': 'Podcasts',
  'institution.webhooks.filterChangeTypes': 'Type of change',
  'institution.webhooks.filterNoFlows': 'No training in this institution.',
  'institution.webhooks.filterNoFlows.edu': 'No course in this institution.',
  'institution.webhooks.filterNoPodcasts': 'No podcast in this institution.',
  'institution.webhooks.activeFilters': 'Active filters',
  'institution.webhooks.changeType.content': 'Content',
  'institution.webhooks.changeType.settings': 'Settings',
  'institution.webhooks.changeType.status': 'Status',
  'institution.webhooks.toast.created': 'Webhook created',
  'institution.webhooks.toast.updated': 'Webhook updated',
  'institution.webhooks.toast.deleted': 'Webhook deleted',
  'institution.webhooks.toast.enabled': 'Webhook enabled',
  'institution.webhooks.toast.disabled': 'Webhook disabled',
  'institution.webhooks.toast.testing': 'Sending test…',
  'institution.webhooks.toast.testOk': 'Test succeeded ({{status}}, {{duration}} ms)',
  'institution.webhooks.toast.copied': 'Copied',
  'institution.webhooks.toast.secretCopied': 'Secret copied',
  'institution.webhooks.error.save': 'Could not save',
  'institution.webhooks.error.delete': 'Could not delete',
  'institution.webhooks.error.toggle': 'Could not change the webhook state',
  'institution.webhooks.error.test': 'The test could not be sent',
  'institution.webhooks.error.logs': 'Could not load the log',
  'institution.webhooks.logsTitle': 'Log — {{name}}',
  'institution.webhooks.logsCount_one': '{{count}} delivery',
  'institution.webhooks.logsCount_other': '{{count}} deliveries',
  'institution.webhooks.logsEmpty': 'No delivery for this webhook.',
  'institution.webhooks.logStatus.success': 'Delivered',
  'institution.webhooks.logStatus.retrying': 'Retry scheduled',
  'institution.webhooks.logStatus.failed': 'Failed',
  'institution.webhooks.logAttempt': 'attempt {{n}}',
  'institution.webhooks.logTest': 'test',
  'institution.webhooks.payloadSent': 'Data sent',
  'institution.webhooks.response': 'Response',
  'institution.webhooks.error': 'Error',
  'institution.webhooks.copy': 'Copy',
  'institution.webhooks.copyPayload': 'Copy data',
  'institution.webhooks.close': 'Close',
  'institution.webhooks.testOk': 'Test succeeded',
  'institution.webhooks.testFailed': 'Test failed',
  'institution.webhooks.testEvent': 'Event',
  'institution.webhooks.testStatus': 'HTTP status',
  'institution.webhooks.testDuration': 'Duration',
  'institution.webhooks.testAgainWith': 'Send another test with',
  'institution.webhooks.testAgain': 'Send',
  'institution.webhooks.deleteTitle': 'Delete this webhook?',
  'institution.webhooks.deleteBody': 'Deliveries stop immediately and the log is deleted.',
  'institution.webhooks.cancel': 'Cancel',
  'institution.webhooks.help.title': 'Receiving and verifying deliveries',
  'institution.webhooks.help.body': 'Each event is sent as a JSON POST: { id, event, createdAt, institution: { id, type }, data }. Reply with a 2xx code within 10 seconds; otherwise the delivery is retried after 1 minute, then 10 minutes. The X-Webhook-Id header stays the same across attempts: use it to ignore duplicates.',
  'institution.webhooks.help.signature': 'Verify the signature: HMAC-SHA256 of “X-Webhook-Timestamp.raw body” with your secret, compared with X-Webhook-Signature (sha256= prefix).',
  'institution.webhooks.help.show': 'Show the verification example',
  'institution.webhooks.help.hide': 'Hide the example',
  'institution.webhooks.help.vocabulary': 'Technical identifiers are the same for every institution: learner, flow = training, block, class = group.',
  'institution.webhooks.help.vocabulary.edu': 'Technical identifiers are shared by every institution: learner = student, flow = course, block = activity, class, score = grade.',
};

/** Libellés des événements (l’API renvoie aussi un libellé français de secours). */
const EVENT_LABELS: Record<string, { fr: [string, string]; frEdu?: [string, string]; en: [string, string]; enEdu?: [string, string] }> = {
  'student.created': {
    fr: ['Apprenant inscrit à une formation', 'Un collaborateur est inscrit à une formation.'],
    frEdu: ['Élève inscrit à un cours', 'Un élève est inscrit à un cours (par sa classe, un parcours ou manuellement).'],
    en: ['Learner enrolled in a training', 'An employee is enrolled in a training.'],
    enEdu: ['Student enrolled in a course', 'A student is enrolled in a course (through a class, a path or manually).'],
  },
  'student.completed': {
    fr: ['Formation terminée', 'Un apprenant a terminé une formation.'],
    frEdu: ['Cours terminé', 'Un élève a terminé un cours.'],
    en: ['Training completed', 'A learner completed a training.'],
    enEdu: ['Course completed', 'A student completed a course.'],
  },
  'block.completed': {
    fr: ['Bloc terminé', 'Un apprenant a terminé un bloc d’une formation.'],
    frEdu: ['Activité terminée', 'Un élève a terminé une activité (bloc) d’un cours.'],
    en: ['Block completed', 'A learner completed a block of a training.'],
    enEdu: ['Activity completed', 'A student completed an activity (block) of a course.'],
  },
  'score.recorded': {
    fr: ['Score enregistré', 'Un score de quiz ou d’évaluation est enregistré.'],
    frEdu: ['Note enregistrée', 'Un élève a répondu à un quiz ou à une évaluation notée.'],
    en: ['Score recorded', 'A quiz or assessment score is recorded.'],
    enEdu: ['Grade recorded', 'A student answered a graded quiz or assessment.'],
  },
  'evaluation.reviewed': {
    fr: ['Copie notée', 'Un professeur a noté une réponse ouverte d’un élève.'],
    en: ['Answer graded', 'A teacher graded a student’s open answer.'],
  },
  'certificate.issued': {
    fr: ['Certificat délivré', 'Un apprenant obtient le certificat d’une formation.'],
    frEdu: ['Attestation délivrée', 'Un élève obtient l’attestation de réussite d’un cours.'],
    en: ['Certificate issued', 'A learner gets the certificate of a training.'],
    enEdu: ['Certificate of achievement issued', 'A student gets the certificate of achievement of a course.'],
  },
  'class.learners_added': {
    fr: ['Élèves ajoutés à une classe', 'Des élèves rejoignent une classe (ajout ou import).'],
    en: ['Students added to a class', 'Students join a class (added or imported).'],
  },
  'class.flow_assigned': {
    fr: ['Cours assigné à une classe', 'Toute une classe est inscrite à un cours.'],
    en: ['Course assigned to a class', 'A whole class is enrolled in a course.'],
  },
  'session.attendees_added': {
    fr: ['Participants inscrits à une session', 'Des collaborateurs sont inscrits à une session de formation.'],
    frEdu: ['Élèves inscrits à une séance', 'Des élèves sont inscrits à une séance (présentiel ou à distance).'],
    en: ['Participants registered for a session', 'Employees are registered for a training session.'],
    enEdu: ['Students registered for a session', 'Students are registered for a session (on site or remote).'],
  },
  'campaign.launched': {
    fr: ['Campagne de formation lancée', 'Une campagne de formation est lancée auprès de ses participants.'],
    en: ['Training campaign launched', 'A training campaign is launched to its participants.'],
  },
  'training_request.created': {
    fr: ['Demande de formation créée', 'Un collaborateur dépose une demande de formation.'],
    frEdu: ['Demande de formation créée', 'Un membre de l’équipe pédagogique dépose une demande de formation.'],
    en: ['Training request created', 'An employee submits a training request.'],
    enEdu: ['Training request created', 'A member of the teaching staff submits a training request.'],
  },
  'training_request.approved': {
    fr: ['Demande de formation validée', 'Une demande de formation est validée.'],
    frEdu: ['Demande de formation validée', 'La direction valide une demande de formation.'],
    en: ['Training request approved', 'A training request is approved.'],
    enEdu: ['Training request approved', 'The leadership team approves a training request.'],
  },
  'training_request.rejected': {
    fr: ['Demande de formation refusée', 'Une demande de formation est refusée.'],
    frEdu: ['Demande de formation refusée', 'La direction refuse une demande de formation.'],
    en: ['Training request rejected', 'A training request is rejected.'],
    enEdu: ['Training request rejected', 'The leadership team rejects a training request.'],
  },
  'flow.published': {
    fr: ['Formation publiée', 'Une formation est publiée.'],
    frEdu: ['Cours publié', 'Un cours est publié.'],
    en: ['Training published', 'A training is published.'],
    enEdu: ['Course published', 'A course is published.'],
  },
  'flow.updated': {
    fr: ['Formation modifiée', 'Une formation publiée est modifiée (envoi regroupé après 2 minutes sans modification).'],
    frEdu: ['Cours modifié', 'Un cours publié est modifié (envoi regroupé après 2 minutes sans modification).'],
    en: ['Training updated', 'A published training is changed (sent once, 2 minutes after the last change).'],
    enEdu: ['Course updated', 'A published course is changed (sent once, 2 minutes after the last change).'],
  },
  'project.published': {
    fr: ['Épisode de podcast publié', 'Un nouvel épisode est publié dans un podcast.'],
    en: ['Podcast episode published', 'A new episode is published in a podcast.'],
  },
};

for (const [id, l] of Object.entries(EVENT_LABELS)) {
  fr[`institution.webhooks.event.${id}.name`] = l.fr[0];
  fr[`institution.webhooks.event.${id}.desc`] = l.fr[1];
  en[`institution.webhooks.event.${id}.name`] = l.en[0];
  en[`institution.webhooks.event.${id}.desc`] = l.en[1];
  if (l.frEdu) {
    fr[`institution.webhooks.event.${id}.name.edu`] = l.frEdu[0];
    fr[`institution.webhooks.event.${id}.desc.edu`] = l.frEdu[1];
  }
  if (l.enEdu) {
    en[`institution.webhooks.event.${id}.name.edu`] = l.enEdu[0];
    en[`institution.webhooks.event.${id}.desc.edu`] = l.enEdu[1];
  }
}

export const webhooksLocales = { fr, en };
